module.exports = __webpack_public_path__ + "static/media/quote-covey-listen.a343f627.jpg";